import React from 'react';
import MoneyIcon from '@material-ui/icons/MonetizationOn';
import ActionIcon from '@material-ui/icons/Whatshot';
import Settings from '@material-ui/icons/Settings';
import AccountTree from '@material-ui/icons/AccountTree';
import Storage from '@material-ui/icons/Storage';
import Search from '@material-ui/icons/Search';
import CloudQueue from '@material-ui/icons/CloudQueue';
import School from '@material-ui/icons/School';
import ViewHeadline from '@material-ui/icons/ViewHeadline';
import '../types/Alert.esm.js';
import { IconType } from '../types/Icon.esm.js';

var DefaultNavigation = /* @__PURE__ */ ((DefaultNavigation2) => {
  DefaultNavigation2["CostOverviewCard"] = "cost-overview-card";
  DefaultNavigation2["AlertInsightsHeader"] = "alert-insights-header";
  return DefaultNavigation2;
})(DefaultNavigation || {});
const getDefaultNavigationItems = (alerts) => {
  const items = [
    {
      navigation: "cost-overview-card" /* CostOverviewCard */,
      icon: /* @__PURE__ */ React.createElement(MoneyIcon, null),
      title: "Cost Overview"
    }
  ];
  if (alerts > 0) {
    items.push({
      navigation: "alert-insights-header" /* AlertInsightsHeader */,
      icon: /* @__PURE__ */ React.createElement(ActionIcon, null),
      title: "Action Items"
    });
  }
  return items;
};
function getIcon(icon) {
  switch (icon) {
    case IconType.Compute:
      return /* @__PURE__ */ React.createElement(Settings, null);
    case IconType.Data:
      return /* @__PURE__ */ React.createElement(AccountTree, null);
    case IconType.Database:
      return /* @__PURE__ */ React.createElement(ViewHeadline, null);
    case IconType.Storage:
      return /* @__PURE__ */ React.createElement(Storage, null);
    case IconType.Search:
      return /* @__PURE__ */ React.createElement(Search, null);
    case IconType.ML:
      return /* @__PURE__ */ React.createElement(School, null);
    default:
      return /* @__PURE__ */ React.createElement(CloudQueue, null);
  }
}

export { DefaultNavigation, getDefaultNavigationItems, getIcon };
//# sourceMappingURL=navigation.esm.js.map
